import Chip from "@mui/joy/Chip";
import Drawer from "@mui/joy/Drawer";
import React from "react";
import { EventSource } from "../../../../models/clinical_event";
import ProofChipDrawerContent from "./ProofChipDrawerContent";

interface ProofChipProps {
  name: string;
  probability?: number;
  eventSources: EventSource[];
}

export const ProofChip = ({ name, probability, eventSources }: ProofChipProps) => {
  const [open, setOpen] = React.useState(false);
  const [sortedSources, setSortedSources] = React.useState<EventSource[]>(eventSources);

  // Sort sources by date
  React.useEffect(() => {
    const sorted = [...eventSources].sort((a, b) => (a.note_date > b.note_date ? 1 : -1));
    setSortedSources(sorted);
  }, [eventSources]);

  const getChipColor = () => {
    if (probability === undefined) {
      // If no probability is provided, check if at least one source has a validation date
      if (eventSources.some((source) => source.validation_date)) return "success";
      return "warning";
    }
    if (probability !== 1) return "warning";
    return "success";
  };

  const displayName = name.length > 25 ? `${name.slice(0, 25)}…` : name;

  return (
    <>
      <Drawer anchor="right" open={open} onClose={() => setOpen(false)} sx={{ width: "400px" }}>
        <ProofChipDrawerContent eventSources={sortedSources} name={name} />
      </Drawer>
      <Chip
        sx={{
          cursor: "pointer",
          maxWidth: 200,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        key={name}
        title={name}
        color={getChipColor()}
        onClick={() => setOpen(true)}
      >
        {displayName}
      </Chip>
    </>
  );
};
